import React, { FunctionComponent, Fragment } from 'react';
import parseHTML from 'html-react-parser';
import { replaceNode } from './utils';
import { IAuthorData } from '../../utils/authorsDataResolver';
import { ICaseStudyCategories } from '../../templates/case-studies-page';
import { IElevatoListItem } from '../../templates/page';

export interface IRichTextProps {
  value?: string | undefined;
  allAuthors?: boolean;
  images?: IKontentRichTextImage[];
  links?: IKontentRichTextLink[];
  modular_content: IKontentItem[];
  articles?: {
    featured: IKontentItem[];
    notFeatured: IKontentItem[];
  };
  latestArticles?: IBlogArticle[];
  caseStudies?: ICaseStudyData;
  nextCaseStudy?: ICaseStudyNext;
  authors?: IAuthorData[];
  caseStudyCategories?: ICaseStudyCategories;
  jobOffersElevato?: IElevatoListItem[];
}

const RichText: FunctionComponent<IRichTextProps> = props => {
  const {
    value,
    allAuthors = false,
    modular_content: linkedItems,
    articles,
    latestArticles,
    caseStudies,
    nextCaseStudy,
    authors,
    caseStudyCategories,
    jobOffersElevato
  } = props;

  if (!value || !value.length) {
    return null;
  }
  const cleaned = value.replace(/(\n|\r)+/, '');
  const children = parseHTML(cleaned, {
    replace: domNode =>
      replaceNode(
        domNode,
        linkedItems,
        allAuthors,
        articles,
        latestArticles,
        caseStudies,
        nextCaseStudy,
        authors,
        caseStudyCategories,
        jobOffersElevato
      )
  });

  return <Fragment>{children}</Fragment>;
};

export default RichText;
